import { render, staticRenderFns } from "./eventoviewfacturas.vue?vue&type=template&id=f53af2ba"
import script from "./eventoviewfacturas.vue?vue&type=script&lang=js"
export * from "./eventoviewfacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports